import React, { useState, useEffect, useRef } from "react";
import { motion, useAnimation, useScroll, useTransform } from "framer-motion";
import "../styles/ZigZagTimeline.css";

import img1 from '../assets/images/timeline1.jpg';
import img2 from '../assets/images/timeline2.jpg';
import img3 from '../assets/images/timeline3.jpg';
import img4 from '../assets/images/timeline4.jpg'; 
import img5 from '../assets/images/timeline5.jpg';
import img6 from '../assets/images/timeline6.jpg';
import img7 from '../assets/images/timeline7.jpg';
import img8 from '../assets/images/timeline8.jpg';
import img9 from '../assets/images/timeline9.jpg';
import img10 from '../assets/images/timeline10.jpg';
import img11 from '../assets/images/timeline11.jpg';
import img12 from '../assets/images/timeline12.jpg';
import img13 from '../assets/images/timeline13.jpg';
import img14 from '../assets/images/timeline14.jpg';
import img15 from '../assets/images/timeline15.jpg';
import img16 from '../assets/images/timeline16.jpg';
import img17 from '../assets/images/timeline17.jpg';
import img18 from '../assets/images/timeline18.jpg';
import img19 from '../assets/images/timeline19.jpg';
import img20 from '../assets/images/timeline20.jpg';
import img21 from '../assets/images/timeline21.jpg';
import img22 from '../assets/images/timeline22.jpg';

const cards = [
  { id: 1, color: "#3b82f6", title: "Contact our Expert's team for Construction Enquiry", img: img1 },
  { id: 2, color: "#a855f7", title: "Our Expert's team will visit and know your Requirements.", img: img2 },
  { id: 3, color: "#ec4899", title: "Our Team will work on your Requirements and Send proposal", img: img3 },
  { id: 4, color: "#f97316", title: "Construction Package Confirmed by clients", img: img4 },
  { id: 5, color: "#22c55e", title: "Our Professional team visit site and works on 2D plan drawing", img: img5 },
  { id: 6, color: "#eab308", title: "2D Plan Drawing Approval Process", img: img6 },
  { id: 7, color: "#6366f1", title: "3D Architectural Drawing Discussion and Finalize", img: img7 },
  { id: 8, color: "#14b8a6", title: "Construction Agreement Signing", img: img8 },
  { id: 9, color: "#f59e0b", title: "Boomi Pooja", img: img9 },
  { id: 10, color: "#10b981", title: "Site Marking & Borewell Drilling Work", img: img10 },
  { id: 11, color: "#8b5cf6", title: "Foundation", img: img11 },
  { id: 12, color: "#f43f5e", title: "Basement", img: img12 },
  { id: 13, color: "#3b82f6", title: "Super Structure", img: img13 },
  { id: 14, color: "#a855f7", title: "Brick Work", img: img14 },
  { id: 15, color: "#ec4899", title: "Electrical & Plumbing Concealed Work", img: img15 },
  { id: 16, color: "#f97316", title: "Plastering Work", img: img16 },
  { id: 17, color: "#22c55e", title: "Tiling Work", img: img17 },
  { id: 18, color: "#eab308", title: "Painting Work", img: img18 },
  { id: 19, color: "#6366f1", title: "Electrical & Plumbing Fittings Work", img: img19 },
  { id: 20, color: "#14b8a6", title: "Doors & Windows Fixing Work", img: img20 },
  { id: 21, color: "#f59e0b", title: "House Warming Function", img: img21 },
  { id: 22, color: "#10b981", title: "Finally with Great Pleasure Handing over the key, Success of us to the client trusted us", img: img22 },
];

const ZigZagTimeline = () => {
  const [activeCard, setActiveCard] = useState(null);
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end center"]
  });

  // Generate card positions with proper zigzag layout
  const getCardPositions = () => {
    const positions = [];
    const rowSize = 4;
    const cardWidth = 280;
    const cardSpacing = 60;
    const rowHeight = 480;
    const containerWidth = 1200;
    
    cards.forEach((card, index) => {
      const rowIndex = Math.floor(index / rowSize);
      const colIndex = index % rowSize;
      const isEvenRow = rowIndex % 2 === 0;
      
      // Calculate X position based on row direction
      let x;
      if (isEvenRow) {
        // Left to right
        x = (containerWidth - (rowSize * cardWidth + (rowSize - 1) * cardSpacing)) / 2 + 
            colIndex * (cardWidth + cardSpacing) + cardWidth / 2;
      } else {
        // Right to left (reverse)
        x = (containerWidth - (rowSize * cardWidth + (rowSize - 1) * cardSpacing)) / 2 + 
            (rowSize - 1 - colIndex) * (cardWidth + cardSpacing) + cardWidth / 2;
      }
      
      const y = rowIndex * rowHeight + 150;
      
      positions.push({ x, y, cardId: card.id, rowIndex, colIndex });
    });
    
    return positions;
  };

  const cardPositions = getCardPositions();

  // Generate SVG path through all cards
  const generatePath = () => {
    if (cardPositions.length === 0) return "";
    
    let path = `M${cardPositions[0].x},${cardPositions[0].y}`;
    
    for (let i = 1; i < cardPositions.length; i++) {
      const current = cardPositions[i];
      const previous = cardPositions[i - 1];
      
      // Add curved connections between rows
      if (current.rowIndex !== previous.rowIndex) {
        const midY = (current.y + previous.y) / 2;
        path += ` Q${previous.x},${midY} ${current.x},${current.y}`;
      } else {
        path += ` L${current.x},${current.y}`;
      }
    }
    
    return path;
  };

  // Ball position based on scroll
  const ballX = useTransform(scrollYProgress, 
    cardPositions.map((_, i) => i / (cardPositions.length - 1)),
    cardPositions.map(pos => pos.x)
  );
  
  const ballY = useTransform(scrollYProgress, 
    cardPositions.map((_, i) => i / (cardPositions.length - 1)),
    cardPositions.map(pos => pos.y)
  );

  // Path progress based on scroll
  const pathLength = useTransform(scrollYProgress, [0, 1], [0, 1]);

  // Update active card based on scroll progress
  useEffect(() => {
    return scrollYProgress.onChange(progress => {
      const cardIndex = Math.floor(progress * cardPositions.length);
      const cardId = cardPositions[cardIndex]?.cardId;
      setActiveCard(cardId || null);
    });
  }, [scrollYProgress, cardPositions]);

  const rows = [];
  const rowSize = 4;
  for (let i = 0; i < cards.length; i += rowSize) {
    rows.push(cards.slice(i, i + rowSize));
  }
  const svgHeight = Math.ceil(cards.length / 4) * 450 + 200;
  return (
    <div className="timeline-container" ref={containerRef}>
      <motion.h1 
        className="timeline-title"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Our Construction Process
      </motion.h1>
      
      <motion.p 
        className="timeline-subtitle"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        From planning to handover – your journey with us
      </motion.p>

      {/* Timeline Content */}
      <div className="timeline-content">
        {/* SVG Path and Ball */}
        <svg 
          className="timeline-svg" 
          width="100%" 
          height={`${svgHeight}px`}
          style={{ position: 'absolute', top: 100, left: 0, zIndex: 1 }}
          viewBox={`0 0 1200 ${svgHeight}`}
        >
          <defs>
            <linearGradient id="pathGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: "#4169E1", stopOpacity: 1 }} />
              <stop offset="50%" style={{ stopColor: "#8B5CF6", stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: "#FF4444", stopOpacity: 1 }} />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
              <feMerge> 
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Animated Path */}
          <motion.path
            d={generatePath()}
            stroke="url(#pathGradient)"
            strokeWidth="4"
            fill="none"
            strokeDasharray="10,5"
            style={{ pathLength }}
            filter="url(#glow)"
          />
          
          {/* Rolling Ball */}
          <motion.g style={{ x: ballX, y: ballY }}>
            <motion.circle
              r="18"
              fill="url(#pathGradient)"
              stroke="#fff"
              strokeWidth="3"
              filter="url(#glow)"
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            />
            <circle
              r="10"
              fill="#fff"
              opacity="0.9"
            />
            <circle
              r="4"
              fill="url(#pathGradient)"
            />
          </motion.g>
        </svg>

        {/* Timeline Cards */}
        <div className="timeline-grid">
          {rows.map((rowCards, rowIndex) => (
            <div
              key={rowIndex}
              className={`timeline-row ${rowIndex % 2 === 1 ? 'row-reverse' : ''}`}
            >
              {rowCards.map((card) => (
                <motion.div
                  key={card.id}
                  className={`timeline-card ${activeCard === card.id ? 'card-active' : ''}`}
                  initial={{ opacity: 0, scale: 0.8, y: 50 }}
                  whileInView={{ opacity: 1, scale: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{
                    duration: 0.6,
                    type: "spring",
                    stiffness: 100
                  }}
                >
                  <img src={card.img} alt={card.title} className="timeline-image" />
                  <motion.div
                    className="circle"
                    style={{ backgroundColor: card.color }}
                    animate={{
                      scale: activeCard === card.id ? 1.4 : 1,
                    }}
                    transition={{ duration: 0.5, type: "spring" }}
                  >
                    {card.id}
                  </motion.div>
                  <h3>{card.title}</h3>
                </motion.div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ZigZagTimeline;
